// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ILinkedApplicationUserResponseDto } from './ILinkedApplicationUserResponseDto';
import {
    ILinkedApplicationUserResponseDtoFromJSON,
    ILinkedApplicationUserResponseDtoFromJSONTyped,
    ILinkedApplicationUserResponseDtoToJSON,
    ILinkedApplicationUserResponseDtoToJSONTyped,
} from './ILinkedApplicationUserResponseDto';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageLinkedApplicationUserResponseDto
 */
export interface IPageLinkedApplicationUserResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    size?: number;
    /**
     * 
     * @type {Array<ILinkedApplicationUserResponseDto>}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    content?: Array<ILinkedApplicationUserResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageLinkedApplicationUserResponseDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageLinkedApplicationUserResponseDto interface.
 */
export function instanceOfIPageLinkedApplicationUserResponseDto(value: object): value is IPageLinkedApplicationUserResponseDto {
    return true;
}

export function IPageLinkedApplicationUserResponseDtoFromJSON(json: any): IPageLinkedApplicationUserResponseDto {
    return IPageLinkedApplicationUserResponseDtoFromJSONTyped(json, false);
}

export function IPageLinkedApplicationUserResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageLinkedApplicationUserResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ILinkedApplicationUserResponseDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageLinkedApplicationUserResponseDtoToJSON(json: any): IPageLinkedApplicationUserResponseDto {
    return IPageLinkedApplicationUserResponseDtoToJSONTyped(json, false);
}

export function IPageLinkedApplicationUserResponseDtoToJSONTyped(value?: IPageLinkedApplicationUserResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ILinkedApplicationUserResponseDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

